import { CommentLine } from "interface/bot"
import IUser from "interface/user/user-interface"

export default function sortTab(a: CommentLine<IUser>, b: CommentLine<IUser>) {
	return new Date(`${b.createdAt}`).getTime() - new Date(`${a.createdAt}`).getTime()
}
